import React from "react";
import { NavLink } from "react-router-dom";

import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
  CNavItem,
  CContainer,
  CCard,
  CCardBody,
  CBadge,
} from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";

import { logoNegative } from "../../../../assets/brand/coreui-logo-sidebar";
import { sygnet } from "../../../../assets/brand/coreui-sygnet-sidebar";

import {
  cilBookmark,
  cilInbox,
  cilPaperPlane,
  cilPencil,
  cilSpeedometer,
  cilStar,
  cilTrash,
} from "@coreui/icons";
import CoreUiHeader from "../../layout/components/CoreUiHeader";
import CoreUiFooter from "../../layout/components/CoreUiFooter";
import AppAside from "../../layout/components/AppAside";
import { useCoreUiSidebarController } from "../../layout/controllers/useCoreUiSidebar";

// eslint-disable-next-line react/prop-types
const EmailNav = ({ children }) => {
  const {
    state: { sidebarShow, unfoldable },
    action: { setSidebarShow, toggleSidebarFold },
  } = useCoreUiSidebarController();

  return (
    <>
      <CSidebar
        colorScheme="light"
        position="fixed"
        unfoldable={unfoldable}
        visible={sidebarShow}
        onVisibleChange={(visible) => {
          setSidebarShow(visible);
        }}
      >
        <CSidebarBrand className="d-none d-md-flex" to="/">
          <CIcon
            className="sidebar-brand-full"
            icon={logoNegative}
            height={35}
          />
          <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
        </CSidebarBrand>
        <CSidebarNav>
          <CNavItem component={NavLink} to="compose">
            <CIcon icon={cilPencil} customClassName="nav-icon" />
            Compose
          </CNavItem>
          <CNavItem component={NavLink} to="inbox">
            <CIcon icon={cilInbox} customClassName="nav-icon" />
            Inbox
            <CBadge color="danger-gradient" className="ms-auto">
              4
            </CBadge>
          </CNavItem>
          <CNavItem color="success" href="#">
            <CIcon icon={cilStar} customClassName="nav-icon" />
            Stared
          </CNavItem>
          <CNavItem color="success" href="#">
            <CIcon icon={cilPaperPlane} customClassName="nav-icon" />
            Sent
          </CNavItem>
          <CNavItem color="success" href="#">
            <CIcon icon={cilTrash} customClassName="nav-icon" />
            Trash
          </CNavItem>
          <CNavItem href="#">
            <CIcon icon={cilBookmark} customClassName="nav-icon" />
            Important
            <CBadge color="info-gradient" className="ms-auto">
              25
            </CBadge>
          </CNavItem>
          <CNavItem component={NavLink} to="/" className="mt-auto">
            <CIcon icon={cilSpeedometer} customClassName="nav-icon" />
            Dashboard
          </CNavItem>
        </CSidebarNav>
        <CSidebarToggler
          className="d-none d-lg-flex"
          onClick={() => toggleSidebarFold()}
        />
      </CSidebar>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <CoreUiHeader />
        <div className="body flex-grow-1 px-3">
          <CContainer lg>
            <CCard>
              <CCardBody>{children}</CCardBody>
            </CCard>
          </CContainer>
        </div>
        <CoreUiFooter />
      </div>
      <AppAside />
    </>
  );
};

export default EmailNav;
